<template>
  <v-card id="frm-login" class="form-card" elevation="0">
    <v-card-title>
      <v-img
        v-if="showLogo"
        lazy-src="@/img/easyplanner-logo.png"
        src="@/img/easyplanner-logo.png"
        height="110px"
        contain
        alt="EASYPLANNER"
      ></v-img>
    </v-card-title>
    <v-card-text>
      <!-- QUESTO DEVE ESSERE UN COMPONENTE -->
      <!-- <div class="loginCard"> -->

      <v-col cols="12" class="text-center" style="margin-bottom: 2vh">
        <h1 class="company-name" v-if="companyInfo != null">
          {{ companyInfo.ragioneSociale }}
        </h1>
        <!-- <p style="font-size: 30px" v-if="companyInfo != null" class="subtitle-1">
        {{ companyInfo.indirizzo }}
      </p> -->
      </v-col>
      <v-col cols="12" style="margin-bottom: 0.5vh">
        <v-text-field
          ref="input"
          label="Username"
          name="username"
          v-model="username"
          v-on:keyup.enter="subitOwnerLogin"
          required
          :rules="[() => !!username || 'This field is required']"
          type="text"
          filled
        ></v-text-field>
      </v-col>

      <v-col cols="12" style="margin-bottom: 1vh">
        <v-text-field
          ref="input"
          label="Password"
          v-on:keyup.enter="subitOwnerLogin"
          v-model="password"
          name="password"
          filled
          required
          :rules="[() => !!password || 'This field is required']"
          :type="passwordFieldType"
          :append-icon="passwordIcon"
          @click:append="showPassword"
          @keydown.enter="submitLogin"
        ></v-text-field>
      </v-col>
      <v-row>
        <v-col style="display: flex; justify-content: center">
          <v-btn text @click="forgotPassword" color="primary">
            Hai dimenticato la password?
          </v-btn>
        </v-col>
      </v-row>
      <v-row style="justify-content: center">
        <v-col cols="5">
          <v-btn class="btnLogin" @click="submitLogin" block>
            LOG IN
            <template v-slot:loader>
              <span>Logging in...</span>
            </template>
          </v-btn>
        </v-col>
      </v-row>
      <v-snackbar v-model="ShowSnackbar" :timeout="5000">
        {{ error }}

        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="error = ''">
            Close
          </v-btn>
        </template>
      </v-snackbar>

      <v-dialog v-model="dialog" width="1000" style="z-index: 10000000">
        <v-card>
          <FrmRecoverPassword
            v-on:close-dialog="closeDialog"
          ></FrmRecoverPassword>
        </v-card>
      </v-dialog>
      <!-- </div> -->
    </v-card-text>
  </v-card>
</template>

<style lang="scss">
.loginCard {
  padding: 60px !important;
}
h1.company-name {
  color: #cf1818;
}
.btnLogin {
  background-color: #5a99b8 !important;
  color: #ffffff !important;
}
</style>

<script>
import EasyPlanClient from "../../utils/EasyPlanClient.js";
import FrmRecoverPassword from "../../components/FrmRecoverPassword/FrmRecoverPassword.vue";
import SessionHelper from "../../utils/SessionHelper";
import Signup from "../../views/Signup";
export default {
  components: { Signup, FrmRecoverPassword },
  props: {
    showLogo: { type: Boolean, default: true },
  },
  data() {
    return {
      companyInfo: null,
      loader: null,
      dialog: false,
      username: "",
      password: "",
      error: "",
      passwordIcon: "mdi-lock",
      passwordFieldType: "password",
    };
  },
  methods: {
    closeDialog: function () {
      this.dialog = false;
    },
    submitLogin() {
      this.loader = "loading";
      EasyPlanClient.User.Login(
        this.username,
        this.password,
        this.$route.params.companyAlias
      )
        .then((res) => {
          EasyPlanClient.SetJWT(res.data.data);
          localStorage.userToken = res.data.data;
          SessionHelper.loadUserInfo(this.$route.params.companyAlias, () => {
            this.$router.push({
              name: "dashboard",
              params: { companyAlias: this.$route.params.companyAlias },
            });
          });
        })
        .catch((error) => {
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          // alert(
          //   "Il tuo account non è stato verificato. Esegui accesso di nuovo e verifica account."
          // );
          this.$router.push("/");
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    showPassword() {
      this.passwordIcon =
        this.passwordIcon === "mdi-lock" ? "mdi-lock-open-variant" : "mdi-lock";
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },

    forgotPassword() {
      this.dialog = true;
    },
  },

  computed: {
    ShowSnackbar: {
      get() {
        return this.error.length > 0;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },
  },
  created: function () {
    if (
      localStorage.userToken != undefined &&
      localStorage.userToken != "null"
    ) {
      EasyPlanClient.SetJWT(localStorage.userToken);
      this.$router.push({
        name: "dashboard",
        params: { companyAlias: this.$route.params.companyAlias },
      });
    } else {
      SessionHelper.loadCompanyInfo(this.$route.params.companyAlias, (info) => {
        this.companyInfo = info;
      });
      // this.loadCompanyInfo();
    }
  },
};
</script>
